module.exports = __webpack_public_path__ + "static/media/blueHospital.36c19e8e.svg";